$(document).ready(function(){

    $(document).on('click', '.custom-search-layout', function () {
  
    const layout = $(this).data('layout'); // get clicked button's data-layout
  
    // Only proceed if this button is not already active
    if (!$(this).hasClass('active')) {
      // Toggle active button class
      $('.custom-search-layout').removeClass('active');
      $(this).addClass('active');
  
      // Loop through products-grid divs
      $('.products-grid').each(function () {
        const gridLayout = $(this).data('layout');
  
        if (gridLayout == layout) {
          $(this).addClass('active');
          // if(layout == "list"){
          //   $(".infinite-scrolling a").attr("data-get_grid", "list");
          // }
          // if(layout == "grid"){
          //   $(".infinite-scrolling a").attr("data-get_grid", "grid");
          // }
          // $(".infinite-scrolling a").attr("data-get_grid", layout);
        } else {
          $(this).removeClass('active');
        }
      });
    }
  });


// grid and list js============================================================


// Select the container where products are loaded
let container = document.querySelector('.col-main');

if (container) {
    // Function to update grids and image classes
    let updateProducts = () => {
        let grids = container.querySelectorAll('.products-grid');
        if (grids.length > 1) {
            let firstGrid = grids[0];
            let nextGrid = firstGrid.nextElementSibling;
            if (nextGrid && nextGrid.classList.contains('products-grid')) {
                nextGrid.classList.add('active');
            }
            firstGrid.classList.remove('active');
        }

        let divs = container.querySelectorAll('.products-grid .no_crop_image');
        divs.forEach((div) => {
            div.classList.remove('col-md-4', 'col-lg-3');
            div.classList.add('col-md-3', 'col-lg-2');
        });
    };

    // Helper function to check grid type
    let isListView = () => {
        let link = document.querySelector('.infinite-scrolling a');
        return link && link.getAttribute('data-get_grid') === 'list';
    };

    // Observe new nodes added to container
    let observer = new MutationObserver(() => {
        if (isListView()) {
            updateProducts();
        }
    });

    observer.observe(container, { childList: true, subtree: true });

    // Run update on click of infinite scroll button
    let infiniteBtn = document.querySelector('.infinite-scrolling');
    if (infiniteBtn) {
        infiniteBtn.addEventListener('click', () => {
            if (isListView()) {
                updateProducts();
            }
        });
    }
}


  // grid and list js end============================================================


  //collection page.
//   var wraps = $('.grid-of-five');
// $('.collection-block-view .collections_pro_list').each( function(e, i){
//   console.log('hh');
//   wraps[Math.floor(i/5)].appendChild(e);
// })

// var divs = $(".collection-block-view .collections_pro_list");
// for(var i = 0; i < divs.length; i+=5) {
//   divs.slice(i, i+5).wrapAll("<div class='grid-of-five'></div>");
// }

  $(document).on('click touchstart', 'p.top-cart', function () {
    setTimeout(function () {
      // Fetch the current page's cart section HTML
      $.get(window.location.pathname , function (data) {
        // Replace only the wrapper div's content with new HTML
        const newContent = $(data).find('.cart-template.custom-meta-object-wrapper').html();
        $('.cart-template.custom-meta-object-wrapper').html(newContent);
      });
    }, 1000); // Adjust delay as needed
  });

  $(document).on('click', '.btn-remove', function () {
    setTimeout(function () {
      // Fetch the current page's cart section HTML
      $.get(window.location.pathname , function (data) {
        // Replace only the wrapper div's content with new HTML
        const newContent = $(data).find('.cart-template.custom-meta-object-wrapper').html();
        $('.cart-template.custom-meta-object-wrapper').html(newContent);
      });
    }, 1000); // Adjust delay as needed
  });
  
  $(".top-header .nav-search .search_icon img").click(function(){
    $(".top-header .nav-search").toggleClass("active");
  });

  $(".option-sidebar").on("click", function(){
    console.log("hello");
    $(".popup-overlay, .popup-content").toggleClass("active");
  });
  
   //for cart page qty
  $(".template-cart .quantity__button").on("mouseover", function(){
    $('.dropdown-cart').css('display','none');
  });
  
  $(".template-cart .quantity__button").on("mouseleave", function(){
    $('.dropdown-cart').css('display','none');
  });
  $(".template-cart .quantity__button").on("click", function () {
     $('.dropdown-cart').css('display','none');
    var $button = $(this);
    var oldValue = $button.parent().find("input.qty").val();
    console.log(oldValue);

    if ($button.hasClass("btn-plus")) {
      var newVal = parseFloat(oldValue) + 1;
    } 
    else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }
    $button.parent().find("input.qty").val(newVal);
  });

});
$(document).on("click",".dropdown-cart .close-drawer svg",function() {
  $("body").removeClass("open-cart");
});
$(document).on("click",".header-bottom .top-cart a.cartToggle",function() {
  event.preventDefault();
  $("body").toggleClass("open-cart");
});

$(".open").on("click", function(){
  $(".popup-overlay, .popup-content").addClass("active");
});

//removes the "active" class to .popup and .popup-content when the "Close" button is clicked 
$(".close").on("click", function(){
  $(".popup-overlay, .popup-content").removeClass("active");
});


$(".first_btn").click(function() {
  $(".refined-widgets a").trigger("click");
});
$(".sec_btn").click(function() {
  $(".close").trigger("click");
});

$(".icon_dropdown_desk").on("click", function(){
 
  $(this).parent("li.dropdown").toggleClass('open_desk_menu');
  $(this).parent(".open_coll_dropdown").find(".site_desk_toggle_nav").toggleClass("hide");
  
});



$(".site-nav .threelevel-list li").each(function() {
  $(this).click(function(e){
    var bold_text = $(this).text().trim();
    localStorage.setItem('bold', bold_text);
    localStorage.getItem('bold');
    var texts = $(this).parents('.dropdown').find('.link_title').attr('data-link_title');
    console.log("texts",texts);
    localStorage.setItem('favourited', texts);
    localStorage.getItem('favourited');
  });
});

$( document ).ready(function() {
  var storage_val =  localStorage.getItem('favourited');
  var storage_bold =  localStorage.getItem('bold');
//   if(storage_bold){
//     $(".sidebar_menu_desk li.dropdown").each(function( index ) {
//     });
//   }

  if(storage_bold){

    $(".site-nav .threelevel-list li").each(function( index ) {
      var bold_class = $(this).text().trim();
      if(storage_bold == bold_class ){
        $(this).addClass("active");

      }
    });
  }
});


$( ".site-nav .link_title" ).click(function(){
  var link__head = $(this).text().trim();
  console.log("link__head",link__head);
  localStorage.setItem('favourited', link__head);
  localStorage.getItem('favourited');

});

$( document ).ready(function() {
  var stor_val =  localStorage.getItem('favourited');
  if(stor_val){

    $(".sidebar_menu_desk li.dropdown").each(function( index ) {
      var main_class = $(this).find('span.link_title').text().trim();;
      if(stor_val == main_class){
        $(this).addClass('open_coll_dropdown');
      }

    });
  }


  $(".template-collection .view-mode a.grid").click(function(){
      $(".collection-block-view").addClass("active");
      $(".collection-block-view_type").removeClass("active");
    });
  $(".template-collection .view-mode a.list").click(function(){
      $(".collection-block-view").removeClass("active");
      $(".collection-block-view_type").addClass("active");
    });
  
});

$(window).scroll(function(){
  var sticky = $('.sticky'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});
 

 jQuery(function() {
  // lille lås, så vi undgår loops
  var swatchIsUpdating = false;

  jQuery(document).on('change', '.swatch :radio', function () {
    if (swatchIsUpdating) return;
    swatchIsUpdating = true;

    var mix_val = '';
    var $form = jQuery(this).closest('form');

    // Byg variant-titel ud fra valgte swatches
    $form.find('.swatch').each(function () {
      jQuery(this).find('.swatch-element input:checked').each(function () {
        mix_val = mix_val + ' / ' + jQuery(this).val();
      });
    });

    var final_val = mix_val.substr(1).trim(); // fjerner første " /"
    var selectedVariantId = null;

    // Find matchende <option> i #product-selectors
    jQuery('#product-selectors option').each(function () {
      if (jQuery(this).text().trim() === final_val) {
        selectedVariantId = jQuery(this).val();

        // Opdater SKU / barcode
        var sku_get = jQuery(this).data('sku') || jQuery(this).attr('data-sku');
        var barcode_get = jQuery(this).data('barcode') || jQuery(this).attr('data-barcode');
        if (sku_get)    jQuery('.sku_get').text(sku_get);
        if (barcode_get) jQuery('.barcode_get').text(barcode_get);

        return false; // break
      }
    });

    if (selectedVariantId) {
      // sæt det skjulte select-felt
      jQuery('#product-selectors').val(selectedVariantId);

      try {
        var productJsonData = JSON.parse(
          document.getElementById('productJson').innerHTML
        );

        var selectedVariant = null;
        if (productJsonData && productJsonData.variants) {
          for (var i = 0; i < productJsonData.variants.length; i++) {
            if (String(productJsonData.variants[i].id) === String(selectedVariantId)) {
              selectedVariant = productJsonData.variants[i];
              break;
            }
          }
        }

        // Brug den selectCallback der allerede er defineret i product.liquid
        if (selectedVariant && typeof selectCallback === 'function') {
          selectCallback(selectedVariant, { domIdPrefix: 'product-selectors' });
        }
      } catch (e) {
        if (window.console && console.warn) {
          console.warn('Error in swatch change handler:', e);
        }
      }
    }

    swatchIsUpdating = false;
  });
});




$(document).ready(function () {
    function updateCartDisplay() {
        var itemCount = parseInt($(".cartCount").text().trim()) || 0;

        if (itemCount > 0) {
            $(".has-items").css("display", "flex");
            $(".no-items").css("display", "none");
        } else {
            $(".has-items").css("display", "none");
            $(".no-items").css("display", "block");
        }
    }

    // Run the function on page load
    updateCartDisplay();

    // Optional: If using AJAX cart updates, listen for changes
    $(document).on("cart:updated", function () {
        updateCartDisplay();
    });
  
});

$(document).ready(function () {
  function updateCart(itemId, quantity) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: itemId,
        quantity: quantity
      },
      dataType: 'json',
      success: function (cart) {
        refreshCartDrawer();
      },
      error: function () {
        console.log('Error updating cart');
      }
    });
  }

  
  // Quantity Increase
  $(document).on('click', '.dropdown-cart .btn-plus', function () {
    let $input = $(this).siblings('.qty');
    let newQuantity = parseInt($input.val()) + 1;
    $input.val(newQuantity);
    let itemId = $input.data('id');
    updateCart(itemId, newQuantity);
  });

  // Quantity Decrease
  $(document).on('click', '.dropdown-cart .btn-minus', function () {
    let $input = $(this).siblings('.qty');
    let newQuantity = Math.max(parseInt($input.val()) - 1, 0);
    $input.val(newQuantity);
    let itemId = $input.data('id');
    updateCart(itemId, newQuantity);
  });

  // Manual Quantity Input Change
  $(document).on('change', '.dropdown-cart .qty', function () {
    let newQuantity = parseInt($(this).val());
    let itemId = $(this).data('id');
    if (newQuantity >= 0) {
      updateCart(itemId, newQuantity);
    }
  });

  // Function to refresh cart drawer
  function refreshCartDrawer() {
    $.get('/cart.js', function (cart) {
      cart.items.forEach(item => {
        let $drawerItem = $('#cart-item-' + item.id);
        $drawerItem.find('.qty').val(item.quantity);
        $drawerItem.find('.cart-collateral span.price').text(Shopify.formatMoney(item.line_price, "{{ shop.money_format }}"));
      });
    }, 'json');
  }

    // Function to refresh cart drawer
  function CustomrefreshCartDrawer() {
    $.get('/cart.js', function (cart) {
      cart.items.forEach(item => {
        let $drawerItem = $('#cart-item-' + item.id);
        $drawerItem.find('.qty').val(item.quantity);
      });
    }, 'json');
  }
});



// document.addEventListener("DOMContentLoaded", function () {

//     const container = document.querySelector(".product-card-desings");
//     const popup = document.querySelector(".popup-signin");
//     const overlay = popup.querySelector(".overlay");
//     const closeBtn = popup.querySelector(".close-btn");
//     container.addEventListener("click", function(event) {

//         const openerDiv = event.target.closest(".popup-opener-button");
//         if (!openerDiv || !container.contains(openerDiv)) return;
//         popup.style.display = "block";
//     });
//     closeBtn.addEventListener("click", () => {
//         popup.style.display = "none";
//     });
//     overlay.addEventListener("click", () => {
//         popup.style.display = "none";
//     });

// });



document.addEventListener('DOMContentLoaded', () => {
  const openerBtns = document.querySelectorAll('.popup-opener-button');
  const popupSignin = document.querySelector('.popup-signin');
  const popupOverlay = document.querySelector('.ps-overlay');
  const popupCloseButton = document.querySelector('.close-btn');

  // Guard: ensure all key elements exist
  if (!popupSignin || !popupOverlay) return;

  const openPopup = () => {
    popupSignin.classList.add('active');
    popupOverlay.classList.add('active');
  };

  const closePopup = () => {
    popupSignin.classList.remove('active');
    popupOverlay.classList.remove('active');
  };

  // Open buttons
  openerBtns.forEach(btn => btn.addEventListener('click', openPopup));

  // Close when clicking overlay or close button
  popupOverlay.addEventListener('click', closePopup);
  popupCloseButton?.addEventListener('click', closePopup);
});

